export default __webpack_public_path__ + "static/media/bg-2.05588ec8.webp";